(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function showToast(msg) {
    var toast = qs('#lia-toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2200);
  }

  /* ---------- Announcement bar rotation ---------- */
  function initAnnouncementBar() {
    var bar = qs('.announcement-bar[data-autorotate]');
    if (!bar) return;
    var track = qs('.announcement-bar__track', bar);
    var items = qsa('.announcement-bar__item', bar);
    if (items.length < 2) return;
    var speed = parseInt(bar.getAttribute('data-autorotate'), 10) * 1000 || 4000;
    var index = 0;
    setInterval(function () {
      index = (index + 1) % items.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      track.style.transition = 'transform 0.5s ease';
    }, speed);
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var toggle = qs('[data-mobile-menu-toggle]');
    var menu = qs('[data-mobile-nav]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var isOpen = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ---------- Search drawer ---------- */
  function initSearch() {
    var toggle = qs('[data-search-toggle]');
    var drawer = qs('[data-search-drawer]');
    var close = qs('[data-search-close]');
    if (!toggle || !drawer) return;
    toggle.addEventListener('click', function () {
      drawer.classList.add('is-open');
      var input = qs('input', drawer);
      if (input) input.focus();
    });
    if (close) close.addEventListener('click', function () { drawer.classList.remove('is-open'); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') drawer.classList.remove('is-open');
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = null;

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function initCartDrawer() {
    cartDrawer = qs('[data-cart-drawer]');
    if (!cartDrawer) return;
    qsa('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });
    qsa('[data-cart-close]', cartDrawer).forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });

    cartDrawer.addEventListener('click', function (e) {
      var item = e.target.closest('[data-cart-item]');
      if (!item) return;
      var key = item.getAttribute('data-key');

      if (e.target.closest('[data-cart-remove]')) {
        changeCartLine(key, 0);
      }
      if (e.target.closest('[data-qty-increase]')) {
        var val = parseInt(qs('[data-qty-value]', item).textContent, 10) + 1;
        changeCartLine(key, val);
      }
      if (e.target.closest('[data-qty-decrease]')) {
        var val2 = parseInt(qs('[data-qty-value]', item).textContent, 10) - 1;
        changeCartLine(key, Math.max(0, val2));
      }
    });

    var noteField = qs('[data-cart-note]', cartDrawer);
    if (noteField) {
      var t;
      noteField.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteField.value })
          });
        }, 500);
      });
    }
  }

  function changeCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () { showToast('Something went wrong updating your cart.'); });
  }

  function renderCartDrawer(cart) {
    updateCartCount(cart.item_count);

    var body = qs('[data-cart-items]');
    var footer = qs('.cart-drawer__footer');

    if (cart.item_count === 0) {
      if (body) {
        body.innerHTML =
          '<div class="cart-drawer__empty"><p>Your cart is empty.</p>' +
          '<a href="/collections/all" class="btn btn--primary">Continue shopping</a></div>';
      }
      if (footer) footer.remove();
      return;
    }

    if (body) {
      body.innerHTML = cart.items
        .map(function (item, i) {
          var variantLine =
            item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="cart-item__variant">' + item.variant_title + '</p>'
              : '';
          var img = item.image
            ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '">'
            : '';
          return (
            '<div class="cart-item" data-cart-item data-key="' + item.key + '">' +
              '<a href="' + item.url + '" class="cart-item__media">' + img + '</a>' +
              '<div class="cart-item__details">' +
                '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' +
                variantLine +
                '<p class="cart-item__price">LE ' + money(item.final_price) + '</p>' +
                '<div class="cart-item__qty">' +
                  '<button type="button" data-qty-decrease aria-label="Decrease quantity">&minus;</button>' +
                  '<span data-qty-value>' + item.quantity + '</span>' +
                  '<button type="button" data-qty-increase aria-label="Increase quantity">&plus;</button>' +
                '</div>' +
              '</div>' +
              '<button class="cart-item__remove" data-cart-remove aria-label="Remove item">&times;</button>' +
            '</div>'
          );
        })
        .join('');
    }

    var subtotal = qs('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = 'LE ' + money(cart.total_price);
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-cart-count', count);
    });
  }

  /* ---------- Add to cart (product form) ---------- */
  function initProductForm() {
    var form = qs('#ProductForm');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = qs('[data-add-to-cart]', form);
      var textEl = qs('[data-add-to-cart-text]', form);
      var originalText = textEl ? textEl.textContent : '';
      if (btn) btn.disabled = true;
      if (textEl) textEl.textContent = 'Adding...';

      var formData = new FormData(form);
      var upsellInputs = qsa('[data-upsell-variant-id]:checked', form);

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () {
          return Promise.all(upsellInputs.map(function (input) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: input.value, quantity: 1 })
            }).then(function (r) { return r.json(); });
          }));
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          renderCartDrawer(cart);
          openCartDrawer();
          showToast('Added to your cart');
        })
        .catch(function () {
          showToast('Could not add this item — please try again.');
        })
        .finally(function () {
          if (btn) btn.disabled = false;
          if (textEl) textEl.textContent = originalText;
        });
    });

    /* Quantity stepper */
    var qtyInput = qs('[data-qty-input]', form);
    var dec = qs('[data-qty-decrease]', form);
    var inc = qs('[data-qty-increase]', form);
    if (qtyInput && dec && inc) {
      dec.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1, 10) - 1);
      });
      inc.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value || 1, 10) + 1;
      });
    }

    /* Option pills -> select matching variant */
    var optionGroups = qsa('[data-option-index]', form);
    if (optionGroups.length && window.LiaProductVariants) {
      optionGroups.forEach(function (group) {
        qsa('.option-pill', group).forEach(function (pill) {
          pill.addEventListener('click', function () {
            qsa('.option-pill', group).forEach(function (p) { p.classList.remove('is-selected'); });
            pill.classList.add('is-selected');
            syncVariant(form);
          });
        });
      });
    }
  }

  function syncVariant(form) {
    var selected = qsa('[data-option-index]', form).map(function (group) {
      var active = qs('.option-pill.is-selected', group);
      return active ? active.getAttribute('data-option-value') : null;
    });
    var variants = window.LiaProductVariants || [];
    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
    if (!match) return;
    var idInput = qs('[data-variant-id]', form);
    if (idInput) idInput.value = match.id;

    var priceWrap = qs('[data-product-price]');
    if (priceWrap) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        priceWrap.innerHTML =
          '<span class="product__price--sale">LE ' + money(match.price) + '</span>' +
          '<span class="product__price--compare">LE ' + money(match.compare_at_price) + '</span>';
      } else {
        priceWrap.innerHTML = '<span>LE ' + money(match.price) + '</span>';
      }
    }

    var addBtn = qs('[data-add-to-cart]');
    var addText = qs('[data-add-to-cart-text]');
    if (addBtn && addText) {
      addBtn.disabled = !match.available;
      addText.textContent = match.available ? 'Add to cart' : 'Sold out';
    }
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var thumbs = qsa('[data-thumb]');
    if (!thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-media-id');
        qsa('.product__gallery-img').forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-media-id') === id);
        });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  }

  /* ---------- Cart page quantity updates ---------- */
  function initCartPage() {
    qsa('[data-cart-page-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var line = input.getAttribute('data-line');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: input.value })
        }).then(function () { window.location.reload(); });
      });
    });
  }

  /* ---------- Slideshow ---------- */
  function initSlideshow() {
    qsa('[data-slideshow]').forEach(function (root) {
      var slides = qsa('[data-slide]', root);
      var dots = qsa('[data-slide-dot]', root);
      if (slides.length < 2) return;
      var index = 0;
      var timer;

      function goTo(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
      }

      function next() { goTo(index + 1); }
      function prev() { goTo(index - 1); }

      function startAutoplay() {
        var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
        if (root.getAttribute('data-autoplay') !== 'true') return;
        clearInterval(timer);
        timer = setInterval(next, speed);
      }

      var nextBtn = qs('[data-slide-next]', root);
      var prevBtn = qs('[data-slide-prev]', root);
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.getAttribute('data-slide-index'), 10));
          startAutoplay();
        });
      });

      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', startAutoplay);

      startAutoplay();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncementBar();
    initMobileMenu();
    initSearch();
    initCartDrawer();
    initProductForm();
    initGallery();
    initCartPage();
    initSlideshow();
  });
})();
